import React, { Fragment } from 'react';

// Return Currency Name
const currencyName = (name) => {
  let countryArray = name.split(':')
  let valLen = countryArray.length;
  let countryName = countryArray[valLen-1]

  return countryName;
}

const BalanceTierSection = ({data,marginApplicable,pageJson,translations}) => (
  <div className="ie-tier-section">
    <div className="ie-tier-section__heading">{translations(pageJson.pageHeading)}</div>
    {
      data.length > 0 && data.map((item,key) => (
        <div className="ie-tier-section__content" key={key}>
          <div className="ie-tier-section__content__heading">{`${translations(pageJson.textTier)} ${key+1}`}</div>
          <dl className="ie-tier-section__content__list">
            <dt>{translations(pageJson.textMargin)}</dt>
            <dd>{item.balanceForEnhancementMargin}</dd>
            </dl>
            {
              marginApplicable === true
              ? <dl className="ie-tier-section__content__list">
                  <dt>{translations(pageJson.textPremiumMargin)}</dt>
                  <dd>{item.balanceEligibleAccountsForPremiumMargin}</dd>
                </dl>
              : ''
            }

        </div>
      ))
    }
  </div>
)

const Dates = ({item, index,text}) => (
  <Fragment className="dates">
    <dt>{`${text} ${index+1}`}</dt>
    <dd>{item}</dd>
  </Fragment>
)

// IE Tier And Setting Section
const IeTierAndSetting = ({data,pageJson,pageJsonBalanceTier,translations}) => {
  if(pageJson !== undefined){
    return(
      <div className="ie-detail-container">
        <div className="ie-detail-container__heading">{`4. ${translations(pageJson.pageHeading)}`}</div>
        {
          data.interestEnhancement !== undefined &&
          <div className="ie-detail-container__content">
            <dl className="ie-detail-container__horizontal-row">
              {
                data.interestEnhancement.tierSettings !== undefined && data.interestEnhancement.tierSettings.baseCurrency !== undefined
                ? [
                    <dt>{translations(pageJson.textCurrency)}</dt>,
                    <dd>{currencyName(data.interestEnhancement.tierSettings.baseCurrency.value)}</dd>
                  ]
                : null
              }
              <dt>{translations(pageJson.textPeriod)}</dt>
              {
                data.interestEnhancement.tierSettings.settlementDate !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType !== undefined
                ? <dd>{data.interestEnhancement.tierSettings.settlementDate.frequencyType.name}</dd>
                : <dd>&nbsp;</dd>
              }
              {
                data.interestEnhancement.tierSettings.settlementDate !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType.name == 'Weekly'
                ? [
                    <dt>{translations(pageJson.textDate)}</dt>,
                    <dd>{data.interestEnhancement.tierSettings.settlementDate.frequencyDetails.name}</dd>
                  ]
                : null
              }
              {
                data.interestEnhancement.tierSettings.settlementDate !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType.name == 'Quarterly'
                ? [
                    <dt>{translations(pageJson.textDate)}</dt>,
                    <dd>{data.interestEnhancement.tierSettings.settlementDate.frequencyDetails.name}</dd>
                  ]
                : null
              }

              {
                data.interestEnhancement.tierSettings.settlementDate !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType.name === 'Monthly'
                ?
                data.interestEnhancement.tierSettings.settlementDate !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType.name === 'Monthly' && data.interestEnhancement.tierSettings.settlementDate.frequencyDetails !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyDetails.name !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyDetails.name === 'Specific day'
                ? [
                    <dt>{translations(pageJson.textDate)}</dt>,
                    <dd>{data.interestEnhancement.tierSettings.settlementDate.frequencyDetails.name}</dd>,
                    <dt>{'Choose Day'}</dt>,
                    <dd>{data.interestEnhancement.tierSettings.settlementDate.frequencyDetailValue.name}</dd>
                  ]
                :
                [
                  <dt>{translations(pageJson.textDate)}</dt>,
                  <dd>{data.interestEnhancement.tierSettings.settlementDate.frequencyDetails.name}</dd>
                ]
                :null

              }
              {
                data.interestEnhancement.tierSettings.settlementDate !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType.name === 'Calender Date'
                ? data.interestEnhancement.tierSettings.settlementDate.dates.filter(item => item !== '').map((item,i) => <Dates item={item} index={i} text={translations(pageJson.textDate)}/>)
                : null
              }
              {
                data.interestEnhancement.tierSettings.settlementDate !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType !== undefined && data.interestEnhancement.tierSettings.settlementDate.frequencyType.name === 'Annually'
                ? [
                    <dt>{translations(pageJson.textDate)}</dt>,
                    <dd>{data.interestEnhancement.tierSettings.settlementDate.annualDate}</dd>
                  ]
                : null
              }
              {
                data.interestEnhancement.tierSettings !== undefined && data.interestEnhancement.tierSettings.poolPositionRule !== undefined
                ? [
                    <dt>{translations(pageJson.textRule)}</dt>,
                    <dd>{data.interestEnhancement.tierSettings.poolPositionRule.name}</dd>
                  ]
                : null
              }
            </dl>
            <hr />
            <BalanceTierSection
              data={data.interestEnhancement.tierSettings !== undefined ? data.interestEnhancement.tierSettings.tiers : []}
              marginApplicable={data.marginApplicable}
              pageJson={pageJsonBalanceTier}
              translations={(word) => translations(word)}
            />
          </div>
        }

      </div>
    )
  }else {
    return null
  }
}

export default IeTierAndSetting;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/IEPreview/IeTierAndSetting.js